import { size } from '@hubble/tokens/web';

const CDN_URL = `https://www.gemini.com/images/currencies/icons/circle`;
const MX_URL = `https://s3.amazonaws.com/MD_Assets/merchant_logos`;
const VISUAL_ELEMENT_SIZE_MAP = {
  sm: size[24],
  md: size[32],
  lg: size[40],
  xl: size[56]
};

export { CDN_URL, MX_URL, VISUAL_ELEMENT_SIZE_MAP };
